import ChangePasswordForm from './ChangePasswordForm';
import SettingsRoute from './SettingsRoute';
import ThemeRoute from './ThemeRoute';
import MfaRoute from './MfaRoute';
import ExportUnitsRoute from './ExportUnitsRoute';
import userApi from '@/api/user';
import { exportUnitsActions } from '@/stores/exportUnitsStore';

const userRouter = {
  path: '/settings',
  element: <SettingsRoute />,
  loader: async () => {
    const { data } = await userApi.getUserInfo();

    return data;
  },
  children: [
    {
      path: 'theme',
      element: <ThemeRoute />,
    },
    {
      path: 'password',
      element: <ChangePasswordForm />,
    },
    {
      path: 'export-units',
      element: <ExportUnitsRoute />,
      loader: async () => {
        const {
          data: { settings },
        } = await userApi.getExportUnits();
        exportUnitsActions.init(settings);

        return null;
      },
    },
    {
      path: 'security',
      element: <MfaRoute />,
      loader: async () => {
        const { data } = await userApi.getUserInfo();

        return data;
      },
    },
  ],
};

export default userRouter;
